import React from "react";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";

const PHASES = {
  recenti: "Ultimi 30 giorni",
  storico: "Storico in background",
  completato: "Completata",
  errore: "Errore",
  interrotto: "Interrotta, riprende",
  "in attesa": "In attesa",
};

// Barra di avanzamento dell'importazione email (batch da 50, ripresa automatica)
// Icona della barra: in corso / errore / completato
function IconaStato({ running, errore }) {
  if (running) return <Loader2 size={15} className="spin" />;
  if (errore) return <AlertTriangle size={15} strokeWidth={2.4} />;
  return <CheckCircle2 size={15} strokeWidth={2.4} />;
}

export default function SyncBar({ status }) {
  const attivi = (status || []).filter((s) => s.total > 0 || s.running || s.error);
  if (attivi.length === 0) return null;
  const tot = attivi.reduce((a, s) => a + s.total, 0);
  const imp = attivi.reduce((a, s) => a + s.imported, 0);
  const running = attivi.some((s) => s.running);
  const errore = attivi.find((s) => s.error);
  const tutteCompletate = attivi.every((s) => s.phase === "completato" && !s.running);
  const done = !running && tot > 0 && (imp >= tot || tutteCompletate);
  if (done && !errore) return null;
  const percent = tot ? Math.min(100, Math.round((imp * 100) / tot)) : 0;
  const phase = attivi.find((s) => s.running)?.phase || attivi[0].phase;
  return (
    <div className={`sync-bar ${errore ? "err" : ""}`} data-testid="sync-bar">
      <div className="sync-row">
        <IconaStato running={running} errore={errore} />
        <span className="sync-label" data-testid="sync-label">
          {errore ? errore.error : `Importazione email · ${PHASES[phase] || phase}`}
        </span>
        <span className="sync-count" data-testid="sync-count">
          {imp.toLocaleString("it-IT")}/{tot.toLocaleString("it-IT")} · {percent}%
        </span>
      </div>
      <div className="sync-track">
        <div className="sync-fill" style={{ width: percent + "%" }} data-testid="sync-fill" />
      </div>
    </div>
  );
}
